import {
  FormTableColumnHeader,
  FormTableColumnHeaderCell,
} from "@porchpass/ui";
import { GhostButton } from "src/components/Buttons";
import {
  ChevronProgressSectionDown,
  ChevronProgressSectionUp,
} from "src/assets/icons";
import InformationTooltip from "../InformationTooltip";

export default function TableHeader({
  onSortByStatus,
  sortDirection,
}: {
  onSortByStatus: () => void;
  sortDirection: "asc" | "desc";
}) {
  const SortIcon =
    sortDirection === "desc"
      ? ChevronProgressSectionDown
      : ChevronProgressSectionUp;

  return (
    <FormTableColumnHeader>
      <FormTableColumnHeaderCell>
        <GhostButton onClick={onSortByStatus}>
          Status
          <SortIcon />
        </GhostButton>
      </FormTableColumnHeaderCell>
      <FormTableColumnHeaderCell>Lender</FormTableColumnHeaderCell>
      <FormTableColumnHeaderCell>
        <span className="inline-flex items-center gap-1.5">
          Primary
          <InformationTooltip
            title="Primary Lender"
            text="The primary lender is used as the default source of truth for each application."
          />
        </span>
      </FormTableColumnHeaderCell>
    </FormTableColumnHeader>
  );
}
